import {
  Archive,
  Calendar,
  BoxIso,
  Globe,
  HomeAltSlim,
  PageFlip,
  Play,
  ProfileCircle,
  SelectWindow,
  Settings,
} from "iconoir-react";
import { IAppViewSection } from "shared/components";

enum StorefrontGroupKey {
  Setup = "SETUP",
  Manage = "MANAGE",
}

export enum StorefrontKey {
  GettingStarted = "GETTING_STARTED",
  BookingWidget = "BOOKING_WIDGET",
  Stockroom = "STOCKROOM",
  Inventory = "INVENTORY",
  Settings = "SETTINGS",
  Site = "SITE",
  Publish = "PUBLISH",
  Orders = "ORDERS",
  Calendar = "CALENDAR",
  People = "PEOPLE",
}

// If the count is set to -1, it will show a spinner
export const storefrontViewSections: IAppViewSection[] = [
  {
    groupKey: StorefrontGroupKey.Setup,
    title: "",
    items: [
      {
        Icon: Play,
        key: StorefrontKey.GettingStarted,
        text: "",
        count: false,
        isSelected: false,
      },
      {
        Icon: HomeAltSlim,
        key: StorefrontKey.BookingWidget,
        text: "",
        count: false,
        isSelected: false,
      },
      {
        Icon: BoxIso,
        key: StorefrontKey.Stockroom,
        text: "",
        count: false,
        isSelected: false,
      },
      {
        Icon: Settings,
        key: StorefrontKey.Settings,
        text: "",
        count: false,
        isSelected: false,
      },
      {
        Icon: Globe,
        key: StorefrontKey.Publish,
        text: "",
        count: false,
        isSelected: false,
        statusTag: { text: "Experimental", visual: "warning" },
      },
      {
        Icon: SelectWindow,
        key: StorefrontKey.Site,
        text: "",
        count: false,
        isSelected: false,
        statusTag: { text: "Experimental", visual: "warning" },
      },
    ],
  },
  {
    groupKey: StorefrontGroupKey.Manage,
    title: "",
    items: [
      {
        Icon: PageFlip,
        key: StorefrontKey.Orders,
        text: "",
        count: false,
        isSelected: false,
      },
      {
        Icon: Calendar,
        key: StorefrontKey.Calendar,
        text: "",
        count: false,
        isSelected: false,
      },
      {
        Icon: Archive,
        key: StorefrontKey.Inventory,
        text: "",
        count: false,
        isSelected: false,
      },
      {
        Icon: ProfileCircle,
        key: StorefrontKey.People,
        text: "",
        count: false,
        isSelected: false,
      },
    ],
  },
];
